<template>
    <footer class="bottomBg">
      <div class="footerShell">
        <div class="footerMain">
          <div class="footerBrand">
            <div class="brandTitle"><img src="../assets/logo.png" alt=""><span>上考</span></div>
            <p>专注医学学习与职业成长</p>
            <span class="brandEnglish">SHANGKAO · LEARN WITH PURPOSE</span>
          </div>
          <div class="bottomContent">
            <div class="aboutus">
                <div class="title">关于上考</div>
                <button type="button" class="name" @click="openAboutus">关于我们</button>
                <button type="button" class="name" @click="openUser">用户协议</button>
                <button type="button" class="name" @click="openPrivacyPolicy">隐私协议</button>
                <button type="button" class="name" @click="openService">联系我们</button>
            </div>
            <div class="joinGroup">
                <div class="title">加群学习</div>
                <div class="groupStudy">
                    <div class="service">
                        <img src="../assets/bottom/img.png" alt="客服二维码">
                        <div class="tip">联系我们</div>
                    </div>
                    <div class="interaction">
                        <img :src="group" alt="学习群二维码">
                        <div class="tip">互动起来</div>
                    </div>

                </div>
            </div>
            <div class="downLoad">
                <div class="title">更多设备</div>
                <div class="downLoadLeft">
                    <div class="wxdown">
                        <img alt="QR Code" src="../assets/bottom/wximg.jpg"/>
                        <div class="tip">微信小程序</div>
                    </div>
                    <div class="appStore">
                        <button type="button" class="btn androidDown" @click="onDownload"><img src="../assets/android.png" alt="">APP Android下载</button>
                        <button type="button" class="btn iosDown" @click="oniosDownload"><img src="../assets/ios.png" alt="">APP Store下载</button>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="bottomInfo">
            <span>© {{currentYear}} 上考</span>
            <a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备2023012733号-3A</a>
        </div>
      </div>
    </footer>
</template>

<script>
import {mapGetters} from "vuex";
import {EventBus} from "@/plugins/EUtils";

export default {
    data(){
        return{
            group:require('../assets/group/all.png'),
            groups:['204','2002','100101','100201','100301','200101','200301','200302','300201']
        }
    },
    computed: {
        ...mapGetters([
            'identityId',
        ]),
        currentYear(){ return new Date().getFullYear() }
    },
    methods:{
        getIdentityId(value){
            if(value){
                this.identity_id = EUtils.deepClone(value);
            }else{
                this.identity_id = this.identityId
            }
            const matched = this.isInGroups(this.identity_id)
            if(matched){
                this.group=require(`../assets/group/${matched}.png`)
            }else{
                this.group=require(`../assets/group/all.png`)
            }
        },
        isInGroups(value) {
            const val = String(value);
            return this.groups.find(group => val.startsWith(String(group)));
        },
        onDownload(){
            window.open('https://a.app.qq.com/o/simple.jsp?pkgname=schema.shangkao.net')
        },
        oniosDownload(){
            window.open('itms-apps://itunes.apple.com/cn/app/id6449732870?mt=8')
        },
        openService(){
            window.open('https://work.weixin.qq.com/kfid/kfc1aaaa420f6e30353')
        },
        openAboutus(){
            window.open('https://api.shangkao.com.cn/abouts/aboutus.html')
        },
        openUser(){
            window.open('https://api.shangkao.com.cn/abouts/user.html')
        },
        openPrivacyPolicy(){
            window.open('https://api.shangkao.com.cn/abouts/secret.html')
        }

    },
    created() {
        EventBus.$on('identity_id',this.getIdentityId)
    },
    beforeDestroy() {
        EventBus.$off('identity_id',this.getIdentityId)
    }
}
</script>

<style scoped lang="scss">
.bottomBg {
    position: relative;
    width: 100%;
    background: linear-gradient(115deg, #25384e, #1e2e41 68%, #1b293a);
    color: #f4f6f8;
    box-sizing: border-box;
    &::before { position: absolute; top: 0; left: 0; right: 0; height: 3px; background: linear-gradient(90deg, #ca8252, #e6b58e 42%, transparent 80%); content: ""; }
    button { font-family: inherit; }
    .footerShell { width: min(100%, 1232px); margin: 0 auto; padding: 46px 26px 0; box-sizing: border-box; }
    .footerMain { display: grid; grid-template-columns: 220px minmax(0, 1fr); gap: 50px; }
    .footerBrand {
        .brandTitle { display: flex; align-items: center; gap: 11px; font-size: 25px; font-weight: 800; letter-spacing: .04em; img { width: 43px; height: 43px; object-fit: contain; } }
        p { margin: 19px 0 9px; color: #d2dbe3; font-size: 13px; line-height: 1.6; }
        .brandEnglish { color: #a9b5c1; font-size: 9px; font-weight: 700; letter-spacing: .12em; }
    }
    .bottomContent { display: grid; grid-template-columns: 130px 210px minmax(0, 1fr); gap: 30px; min-width: 0; }
    .title { margin: 4px 0 19px; color: #f5f6f8; font-size: 15px; font-weight: 700; }
    .aboutus { display: flex; flex-direction: column; align-items: flex-start; }
    .name { display: block; margin: 0 0 11px; padding: 0; border: 0; background: transparent; color: #b6c2cf; font-size: 12px; line-height: 1.5; text-align: left; cursor: pointer; transition: color .16s; &:hover, &:focus-visible { color: #f0b689; outline: 0; } }
    .joinGroup, .downLoad { min-width: 0; }
    .groupStudy, .downLoadLeft { display: flex; align-items: flex-start; gap: 13px; }
    .groupStudy img, .wxdown img { display: block; width: 82px; height: 82px; padding: 5px; border-radius: 9px; background: #fff; box-sizing: border-box; object-fit: contain; }
    .tip { margin-top: 9px; color: #afbdc9; font-size: 11px; line-height: 1.4; text-align: center; white-space: nowrap; }
    .appStore { display: flex; flex-direction: column; gap: 9px; min-width: 0; }
    .appStore .btn {
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
        width: 176px;
        min-height: 37px;
        padding: 6px 13px;
        border: 1px solid rgba(218, 228, 239, .22);
        border-radius: 9px;
        background: rgba(255, 255, 255, .07);
        color: #e6ecf2;
        font-size: 11px;
        white-space: nowrap;
        cursor: pointer;
        transition: border-color .16s, background .16s;
        img { width: 18px; height: 18px; object-fit: contain; filter: grayscale(1) brightness(1.8); }
        &:hover, &:focus-visible { border-color: rgba(235, 184, 141, .65); background: rgba(202, 130, 82, .2); outline: 0; }
    }
    .bottomInfo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin-top: 39px;
        padding: 17px 0 21px;
        border-top: 1px solid rgba(218, 228, 239, .14);
        color: #90a0af;
        font-size: 11px;
        a { color: inherit; text-decoration: none; &:hover { color: #f0b689; } }
    }
}
@media (max-width: 980px) {
    .bottomBg .footerMain { grid-template-columns: 1fr; gap: 30px; }
    .bottomBg .footerBrand p { margin: 8px 0 5px; }
    .bottomBg .bottomContent { grid-template-columns: 130px 210px minmax(0, 1fr); }
}
@media (max-width: 700px) {
    .bottomBg .footerShell { padding: 33px 18px 0; }
    .bottomBg .footerMain { gap: 26px; }
    .bottomBg .footerBrand .brandTitle { font-size: 22px; img { width: 38px; height: 38px; } }
    .bottomBg .bottomContent { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 25px 16px; }
    .bottomBg .title { margin-bottom: 14px; }
    .bottomBg .groupStudy { gap: 10px; }
    .bottomBg .groupStudy img { width: 68px; height: 68px; }
    .bottomBg .downLoad { grid-column: 1 / -1; padding-top: 22px; border-top: 1px solid rgba(218, 228, 239, .14); }
    .bottomBg .downLoadLeft { gap: 18px; }
    .bottomBg .wxdown img { width: 76px; height: 76px; }
    .bottomBg .bottomInfo { margin-top: 27px; }
}
@media (max-width: 390px) {
    .bottomBg .footerShell { padding-left: 14px; padding-right: 14px; }
    .bottomBg .groupStudy img { width: 62px; height: 62px; }
    .bottomBg .appStore .btn { width: 162px; }
}
</style>
